import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceHighlightDataSafe } from '../../../context/resourceDataContext.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { mediaNotMobile } from '@fabric-app/ui/constants/styled-utils';
import { noteTextFormat } from '@fabric-app/utils/text';

const TextWrapper = styled.div.withConfig({
  displayName: "ResourceHighlightText__TextWrapper",
  componentId: "sc-928d3058-0"
})([
  `padding:1.5rem;`
]);
const Text = styled.span.withConfig({
  displayName: "ResourceHighlightText__Text",
  componentId: "sc-928d3058-1"
})([
  `line-height:1.6;color:`,
  `;background:rgba(186,206,255,0.3);box-shadow:0px 2.25px 0px 0px rgba(186,206,255,0.3),0px -2.25px 0px 0px rgba(186,206,255,0.3);`,
  `{font-size:1.0625rem;line-height:1.7;}`
], cssVar["color-text-primary"], mediaNotMobile);
const ResourceHighlightText = () => {
  const { resource } = useResourceHighlightDataSafe();
  return /* @__PURE__ */ jsx(TextWrapper, {
    "data-pan-id-ignore-resource-drag-resize": "xy",
    children: resource.data.extensionContext?.text && /* @__PURE__ */ jsx(Text, {
      children: noteTextFormat(resource.data.extensionContext?.text)
    })
  });
};

export { ResourceHighlightText };
//# sourceMappingURL=ResourceHighlightText.js.map
